'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBusinessCenter = function MdBusinessCenter(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 11.6v-3.2h-6.8v3.2h6.8z m10 0c1.8 0 3.2 1.6 3.2 3.4v5c0 1.8-1.4 3.4-3.2 3.4h-10v-3.4h-6.8v3.4h-10c-1.8 0-3.2-1.5-3.2-3.4v-5c0-1.8 1.4-3.4 3.2-3.4h6.7v-3.2l3.3-3.4h6.7l3.3 3.4v3.2h6.8z m-16.8 15h6.8v-1.6h11.6v6.6c0 1.9-1.5 3.4-3.4 3.4h-23.2c-1.9 0-3.4-1.5-3.4-3.4v-6.6h11.6v1.6z' })
        )
    );
};

exports.default = MdBusinessCenter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/business-center.js
// module id = 1268
// module chunks = 168707334958949